import { ViewModel,View, ObservableArray } from "binder"
import  { NoSaleLockReportsView } from "./noSaleLockReports-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";

export class NoSaleLockReportsViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست انتقالی های احتیاط';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.reportRows = ObservableArray.create<noSaleLockRow>();
        this.from = moment.utc();
        this.until = moment.utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new NoSaleLockReportsView();
    }
    public getTypeId(): string {
        return "VM-3DC94E81-F097-4031-94AD-8324961DF71D"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set reportRows(v: ObservableArray<noSaleLockRow>) { this._reportRows = v; } public get reportRows(): ObservableArray<noSaleLockRow> { return this._reportRows;} private _reportRows: ObservableArray<noSaleLockRow>;
   
   
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/NoSaleLockProductsReport',{
                From:this.from,
                Until:this.until
            });
            this.reportRows.update(...result.Rows.map((x,i)=>{
                let r = new noSaleLockRow(this);
                r.operatorName = x.OperatorName;
                r.index = i+1;
                r.billNo = x.BillNo;
                r.type = (x.Type == 1 || x.Type == 3) ? 'خروج از احتیاط' : (x.Type == 2 || x.Type == 4) ? 'ورود به احتیاط' : '';
                r.warehooseName = x.WarehouseName;
                r.productName = x.ProductName;
                r.productCode = x.ProductCode;
                r.productCarModel = x.ProductCarModel;
                r.amount = x.Count;
                r.time = moment.utc(x.OperationDate);
                return r;
            }));
            return null;
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(1,1);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class noSaleLockRow extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:NoSaleLockReportsViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : NoSaleLockReportsViewModel;
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set operatorName(v: string) { this._operatorName = v; } public get operatorName(): string { return this._operatorName;} private _operatorName: string;
    public set billNo(v: string) { this._billNo = v; } public get billNo(): string { return this._billNo;} private _billNo: string;
    public set type(v: string) { this._type = v; } public get type(): string { return this._type;} private _type: string;
    public set warehooseName(v: string) { this._warehooseName = v; } public get warehooseName(): string { return this._warehooseName;} private _warehooseName: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
}
